<template>
  <div>
    <transition name="fade">
      <b-card no-body class="dashboard-card">
        <div class="card-smallHeader card-header-action" v-b-toggle.collapseGestion>
          <i class="fa fa-list-alt mr-2"></i>
          <strong>Tableau de pilotage</strong>
          <div class="card-header-actions">
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
          </div>
        </div>
        <b-collapse id="collapseGestion" :visible="true">
          <b-card-body class="xsmall-padding">
            <table id="dashboardGestion" class="dashboard full-width">
              <thead style="position: sticky; top:0; background-color: #FFF;">
                <tr>
                  <td style="border-left: none; " colspan="2"></td>
                  <td style="border-left: none; border-right: none;" colspan="10">
                    <i v-if="infoGlobalDossier" id="info-total-dossier-nir-type" class="float-right ml-2 fa fa-info-circle fa-1_5x text-primary"></i><span class="float-right" v-html="infoGlobalDossier"></span>
                    <b-tooltip v-if="infoGlobalDossierSup" target="info-total-dossier-nir-type" triggers="hover click" placement="bottomleft">
                      <span v-html="infoGlobalDossierSup"></span>
                    </b-tooltip>
                  </td>
                </tr>
                <tr>
                  <td class="headerDashboard firstColumn p-1" style="text-align: center;" colspan="2"><b>Mode de visualisation</b></td>
                  <td colspan="10" style="text-align: left;border-right:none;" class="col-separateur">
                    <b-form-select style="width: 288px;display: inline-block;" v-model="modeVisualisation" class="">
                      <b-form-select-option value="monActiviteProd">Production - Mon activité</b-form-select-option>
                      <b-form-select-option value="monEquipeProd">Production - Mon équipe</b-form-select-option>
                      <b-form-select-option value="monServiceProd">Production - Mon service</b-form-select-option>
                      <b-form-select-option v-if="isManager()" value="monEquipeManagement">Management - Mon équipe</b-form-select-option>
                      <b-form-select-option v-if="canManageService()" value="monServiceManagement">Management - Mon service</b-form-select-option>
                    </b-form-select>
                      &nbsp;&nbsp;
                    <vue-excel-xlsx
                      v-if="modeVisualisation === 'monServiceManagement' || modeVisualisation === 'monEquipeManagement'"
                      :data="excelData"
                      :columns="excelColumns"
                      class="btn btn-primary"
                      :filename="'export_tdb_'+getTimestamp()">
                      <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
                    </vue-excel-xlsx>
                    <span class="float-right" v-html="infoGestionnaireDossier"></span>
                  </td>
                </tr>
                <tr class="row-separateur" style="border-top:none;">
                  <td :colspan="statusPrincipaux.length + 3" style="border-top:none;"></td>
                  <td class="col-separateur"></td>
                  <td :colspan="statusTraites.length" style="border-top:none;"></td>
                </tr>
                <tr class="">
                  <th class="headerDashboard firstColumn" colspan="2">Corbeilles</th>
                  <th :class="statusP.libelle_technique === 'en_attente_dpc' ? 'headerDashboard-light' : 'headerDashboard'" v-for="(statusP, index) in statusPrincipaux" :key="statusP.libelle_bo">{{ statusP.libelle_technique === 'en_attente_dpc' ? 'dont '+statusP.libelle_bo : statusP.libelle_bo }}</th>
                  <th class="headerDashboard">Total</th>
                  <th class="col-separateur"></th>
                  <th :class="(statusT.libelle_bo === 'DPC (J)') ? 'headerDashboard-light' : 'headerDashboard'" v-for="(statusT, index) in statusTraites" :key="statusT.libelle_bo">{{ statusT.libelle_bo }}</th>
                </tr>
              </thead>
              <tbody v-if="loadingDashboard">
                <tr>
                  <td :colspan="statusPrincipaux.length + 3 "><loading-field v-if="loadingDashboard" /></td>
                  <td class="col-separateur"></td>
                  <td :colspan="statusTraites.length"></td>
                </tr>
              </tbody>
              <tbody v-if="!loadingDashboard">
                <tr v-for="basket in systemBaskets" :key="'gestion-row-'+basket.id">
                  <td :style="getStyle(basket)" class="text-left">
                    {{ basket.libelle ? basket.libelle : basket.nom.toUpperCase()+' '+basket.prenom.substring(0,1).toUpperCase()+'.' }}
                    <span v-if="modeVisualisation === 'monServiceManagement'">({{ basket.libelle_equipe }})</span>
                  </td>
                  <td :style="getStyle(basket)" class="basketDashboard action"><i v-if="canDeleteBasket(basket)" class="fa fa-trash clickable text-danger" @click="removeBasket(basket.id)"></i></td>
                  <td v-for="(statusP, index) in statusPrincipaux" :key="'gestion-col-'+statusP.id" :class="{disabled: disableColumn('a_affecter',statusP)}">
                    <span v-if="statistiquesPrincipales[basket.id][statusP.id] !== undefined">
                      <span v-if="disableColumn('a_affecter',statusP)"> - </span>
                      <a v-else href="#" :id="`stat_${basket.id}_${statusP.id}`" @click.prevent="getDossiersGestion(statusP,basket)">{{ getFormatedNumber(statistiquesPrincipales[basket.id][statusP.id]['stats']) }}</a>
                      <b-tooltip v-if="showTooltipStatType(basket.id,statusP.id)" :target="`stat_${basket.id}_${statusP.id}`" triggers="hover" placement="left">
                        <ul>
                          <li v-for="(statType, index) in statistiquesPrincipales[basket.id][statusP.id]['type']" :key="index">{{ getLibelleType(index) }} - {{ statType }}</li>
                        </ul>
                      </b-tooltip>
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td>
                    <a :id="`stat_${basket.id}_total`" v-if="statistiquesPrincipales[basket.id] && statistiquesPrincipales[basket.id]['total'] !== undefined" href="#" @click.prevent="getDossiersGestion('total',basket)">{{  getFormatedNumber(statistiquesPrincipales[basket.id]['total']['stats']) }}</a>
                    <span v-else> - </span>
                    <b-tooltip v-if="statistiquesPrincipales[basket.id]['total']['stats']" :target="`stat_${basket.id}_total`" triggers="hover" placement="left">
                      <ul>
                        <li v-for="(statType, index) in statistiquesPrincipales[basket.id]['total']['type']" :key="index">{{ getLibelleType(index) }} - {{ statType }}</li>
                      </ul>
                    </b-tooltip>
                  </td>
                  <td class="col-separateur"></td>
                  <td v-for="(statusT, index) in statusTraites" :key="'gestion-col-'+statusT.libelle_bo">
                    <a :id="`stat_${basket.id}_traites_${index}`" v-if="statistiquesTraites[basket.id][index] !== undefined" href="#" @click.prevent="getDossiersGestion(statusT,basket)">{{  getFormatedNumber(statistiquesTraites[basket.id][index]['stats']) }}</a>
                    <span v-else> - </span>
                    <b-tooltip v-if="statistiquesTraites[basket.id][index]['stats']" :target="`stat_${basket.id}_traites_${index}`" triggers="hover" placement="left">
                      <ul>
                        <li v-for="(statType, index) in statistiquesTraites[basket.id][index]['type']" :key="index">{{ getLibelleType(index) }} - {{ statType }}</li>
                      </ul>
                    </b-tooltip>
                  </td>

                </tr>
                <tr class="row-separateur" v-if="userBaskets.length > 0">
                  <td :colspan="statusPrincipaux.length + 3"></td>
                  <td class="col-separateur"></td>
                  <td :colspan="statusTraites.length"></td>
                </tr>
                <tr v-for="basket in userBaskets" :key="'gestion-row-'+basket.id">
                  <td :style="getStyle(basket)" class="text-left">{{ basket.libelle }}</td>
                  <td :style="getStyle(basket)" class="basketDashboard action"><i v-if="canDeleteBasket(basket)" class="fa fa-trash clickable text-danger" @click="removeBasket(basket.id)"></i></td>
                  <td v-for="(statusP, index) in statusPrincipaux" :key="'gestion-col-'+statusP.id" :class="{disabled: disableColumn('a_affecter',statusP)}">
                    <span v-if="statistiquesPrincipales[basket.id][statusP.id] !== undefined">
                      <span v-if="disableColumn('a_affecter',statusP)"> - </span>
                      <a v-else href="#" @click.prevent="getDossiersGestion(statusP,basket)">{{ getFormatedNumber(statistiquesPrincipales[basket.id][statusP.id]['stats']) }}</a>
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td>
                    <a v-if="statistiquesPrincipales[basket.id] && statistiquesPrincipales[basket.id]['total'] !== undefined" href="#" @click.prevent="getDossiersGestion('total',basket)">{{ getFormatedNumber(statistiquesPrincipales[basket.id]['total']['stats']) }}</a>
                    <span v-else> - </span>
                  </td>
                  <td class="col-separateur"></td>
                  <td v-for="(statusT, index) in statusTraites" :key="'gestion-col-'+statusT.libelle_bo">
                    <a v-if="statistiquesTraites[basket.id][index] !== undefined" href="#" @click.prevent="getDossiersGestion(statusT,basket)">{{ getFormatedNumber(statistiquesTraites[basket.id][index]['stats']) }}</a>
                    <span v-else> - </span>
                  </td>
                </tr>
                <!-- <tr v-if="statsAAffecter !== ''">
                  <td class="headerDashboard" colspan="2"><b>Total "A affecter"</b></td>
                  <td :style="getStyle({})"><b>{{ statsAAffecter }}</b></td>
                  <td colspan="9" class="btl-only"></td>
                </tr> -->
              </tbody>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth';
import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";
import {isResponsable as isResponsableEquipe} from "@/utils/userHelper";
import {isEmpty} from "@/utils/fileHelper";
import loadingField from "@/components/LoadingField";

export default {
  props: [],
  components: {
    loadingField
  },
  data() {
    return {
      loadingDashboard: false,
      infoGlobalDossier: '',
      infoGestionnaireDossier: '',
      infoGlobalDossierSup: '',
      allBaskets: [],
      systemBaskets: [],
      userBaskets: [],
      statusPrincipaux: [],
      statusTraites: [],
      statusAlertes: [],
      statistiquesPrincipales: [],
      statistiquesTraites: [],
      statistiquesAlertes: [],
      // statsAAffecter: '',
      textBoutonSwitch: 'Passer au suivi des gestionnaires',
      actualDashboard: 'baskets',
      textHeader: 'Corbeilles',
      modeVisualisation: 'monActiviteProd',
      excelColumns : [
        {
          label: "Gestionnaire",
          field: "gestionnaire",
        },
        {
          label: "Profil",
          field: "profil",
        },
        {
          label: "Equipe",
          field: "equipe",
        },
        {
          label: "A traiter",
          field: "a_traiter",
        },
        {
          label: "En attente",
          field: "en_attente",
        },
        {
          label: "dont DPC",
          field: "en_attente_dpc",
        },
        {
          label: "Total",
          field: "total",
        },
        {
          label: "En attente (J)",
          field: "en_attente_j",
        },
        {
          label: "DPC (J)",
          field: "en_attente_dpc_j",
        },
        {
          label: "Traité (J)",
          field: "traite_j",
        },
        {
          label: "Traité (S)",
          field: "traite_s",
        },
      ],
      excelData: [],
      loadingBasket: {},
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  mounted() {
    this.getGestionDashboard();
    // this.getBaskets()

    this.$event.on('refreshDashboard', () => {
      this.getGestionDashboard();
    })

    // TODO : comprendre pourquoi ça ne fonctionne pas
    // this.$event.on('changeModeVisualisation', (modeVisualisation) => {
    //   // console.log('modeVisualisation',modeVisualisation)
    //   this.modeVisualisation = modeVisualisation;
    //   // console.log('this.modeVisualisation',this.modeVisualisation)
    // });

    this.getInfoGlobalDossier();
  },
  watch: {
    modeVisualisation: function() {
      this.$parent.modeVisualisation = this.modeVisualisation;
      this.$parent.clearForm();
      // this.statsAAffecter = ''
      // this.getBaskets()
      this.getGestionDashboard();
      // if (this.modeVisualisation === 'monServiceManagement') {
      //   this.fetchData();
      // }
      this.$event.emit('changeModeVisualisation', this.modeVisualisation);
    },
    systemBaskets: function () {
      // if (this.modeVisualisation === 'monServiceManagement' && !isEmpty(this.systemBaskets)) {
      //   this.fetchData();
      // }
      // console.log('passe watch systembasket');
      if(!isEmpty(this.systemBaskets)){
        // console.log('passe not empty watch systembasket');
        this.setLoading(this.systemBaskets);
        this.getGestionDashboardBasketStats(this.systemBaskets)
      }else{
        // console.log('passe empty watch systembasket');
      }
    },
    userBaskets: function () {
      if(!isEmpty(this.userBaskets)){
        this.setLoading(this.userBaskets);
        this.getGestionDashboardBasketStats(this.userBaskets)
      }
    },
    loadingBasket() {
      // console.log('dans watcher')
      let findLoading = this.loadingBasket.find(loading => loading === true);
      // console.log('findLoading',findLoading)
      if (!findLoading) {
        this.loadingDashboard = false;
      }
    },
    // loadingBasket: {
    //   deep: true,
    //   handler() {
    //     console.log('dans watcher')
    //     let findLoading = this.loadingBasket.find(loading => loading === true);
    //     console.log('findLoading',findLoading)
    //     if (!findLoading) {
    //       this.loadingDashboard = false;
    //     }
    //   }
    // },
  },
  methods: {
    getDossiersGestion(status, basket) {
      this.$eventBus.$emit('setAdvancedSearch', true)
      // console.log(basket)
      // oncommence par vider les précédent résultat
      this.$parent.$refs.dashboard_dossier_table.$refs.table.data = [];
      this.$parent.statusIds = []
      this.$parent.selectedStatus = []
      this.$parent.clearForm()
      this.$parent.modeVisualisation = this.modeVisualisation
      let criteres = []
      if (['monActiviteProd','monEquipeProd','monServiceProd'].indexOf(this.modeVisualisation) >= 0) {
        this.$parent.basketId = basket.id
        criteres = basket.criteres
        this.$parent.traitementId = basket.traitement_id
        this.$parent.selectedTraitementId = basket.traitement_id
      } else {
        this.$parent.gestionnaire = basket.id
        this.$parent.gestionnaireNom = basket.nom
        this.$parent.gestionnairePrenom = basket.prenom
      }
      // console.log(this.$parent.basketId)

      // console.log('status',status)
      if (status === 'total') {
        for (let statut of this.statusPrincipaux) {
          // On ne garde le statut "A Affecter" que pour le mode 'monActiviteProd' de ceux qui ont le droit d'affecter
          if ((this.modeVisualisation === 'monActiviteProd' && (hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL))) || statut.libelle_technique !== 'a_affecter') {
            this.$parent.statusIds.push(statut.id)
            this.$parent.selectedStatus.push(statut.id)
          }
        }
      } else if (status.libelle_bo === 'En Attente (J)') {
        this.$parent.statusTraite = 'enAttenteJ'
        this.$parent.statusIds.push(status.status_id)
        this.$parent.selectedStatus.push(status.status_id)
      } else if (status.libelle_bo === 'DPC (J)') {
        this.$parent.statusTraite = 'dpcJ'
        this.$parent.statusIds = []
        // this.$parent.selectedStatus.push(status.status_id)
      } else if (status.libelle_bo === 'Traité (J)') {
        this.$parent.statusTraite = 'traiteJ'
        this.$parent.statusIds.push(status.status_id)
        this.$parent.selectedStatus.push(status.status_id)
      } else if (status.libelle_bo === 'Traité (S)') {
        this.$parent.statusTraite = 'traiteS'
        this.$parent.statusIds.push(status.status_id)
        this.$parent.selectedStatus.push(status.status_id)
      } else if (status.libelle_bo === 'Alertes OT') {
        this.$parent.alerte = 'alertesOT'
        this.$parent.statusIds = status.status_id
        this.$parent.selectedStatus = status.status_id
      } else if (status.libelle_bo === 'Alertes OA') {
        this.$parent.alerte = 'alertesOA'
        this.$parent.statusIds = status.status_id
        this.$parent.selectedStatus = status.status_id
      } else {
        this.$parent.statusTraite = '';
        this.$parent.alerte = '';
        if (parseInt(status.id) !== 0 && parseInt(status.id) !== -1) {
          this.$parent.statusIds.push(status.id)
          this.$parent.selectedStatus.push(status.id)
        }
      }
      if (status !== 'total' && status.libelle_technique !== 'a_affecter') {
        // Si on est en mode mon activité, on ajoutel'id du user dans la partie gestionnaire affecté
        if (this.modeVisualisation === 'monActiviteProd') {
          this.$parent.gestionnaire = getUser().id;
        }
      }
      // console.log('dans getGestion : ', this.$parent.statusIds)

      this.$parent.populateStatus()
      for (let key in criteres) {
        // console.log(key)
        if (key === 'canal' && criteres[key]) {
          this.$parent.selectedCanals = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateCanal()
        } else if (key === 'type') {
          this.$parent.selectedTypes = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateType()
        } else if (key === 'oags') {
          this.$parent.selectedOags = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateOags()
        } else if (key === 'oaps') {
          this.$parent.selectedOaps = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateOaps()
        }  else if (key === 'campagne') {
          this.$parent.selectedCampagnes = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateCampagne()
        } else if (key === 'group_siren') {
          this.$parent.selectedGroupSirens = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateGroupSiren()
        } else if (key === 'segment') {
          this.$parent.selectedSegments = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateSegment()
        } else if (key === 'produit') {
          this.$parent.selectedProduits = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateProduit()
        } else if (key === 'status_prestij') {
          // console.log('status_prestij',criteres[key])
          this.$parent.selectedStatusPrestij = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateStatusPrestij()
        } else if (key === 'segment_commercial') {
          this.$parent.selectedSegmentsCommerciaux = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateSegmentCommerciaux()
        } else if (key === 'delegation') {
          this.$parent.selectedDelegations = criteres[key]
          // On repeuple le select multiple
          this.$parent.populateDelegation()
        } else if (key === 'statusId') {
          if (criteres[key].length > 0) {
            let statusParentId = [];
            let sousStatusId = [];
            let statusId = criteres[key].map(elem=> parseInt(elem, 10));
            let statuts = this.$parent.allStatus.filter(status => statusId.indexOf(status.id) > -1);
            if (statuts.length === 0) {
              for (let statusParent of this.$parent.allStatus) {
                for (let sousStatus of statusParent.sous_statuts) {
                  if (statusId.indexOf(sousStatus.id) > -1) {
                    sousStatusId.push(sousStatus.id);
                    statusParentId = [sousStatus.parent_id];
                  }
                }
              }
            } else {
              statusParentId = statuts.map(status => status.id);
            }
            this.$parent.selectedStatus = statusParentId;
            this.$parent.selectedSousStatus = sousStatusId;
            this.$parent.populateStatus();
            this.$parent.getSousStatus();
            this.$parent.populateSousStatus();
          }
        } else if (key === 'typeUrgence' && criteres[key]) {
          this.$parent.selectedTypesUrgences = criteres[key]
          this.$parent.populateTypeUrgence()
        } else if (key === 'flag' && criteres[key]) {
          this.$parent.selectedFlags = criteres[key]
          this.$parent.populateFlag()
        } else if (key === 'codesPtz' && criteres[key]) {
          this.$parent.selectedCodePtz = criteres[key]
          this.$parent.populateCodePtz()
        } else if (key === 'exclureGroupeSiren' && criteres[key]) {
          this.$parent.exclureGroupeSiren = criteres[key] == "1" ? true : false
        } else if (key === 'exclureDateSinistre' && criteres[key]) {
          this.$parent.exclureDateSinistre = criteres[key] == "1" ? true : false
        }
        else {
          this.$parent[key] = criteres[key] !== null ? criteres[key] : ''
        }
        // Si on est en mode mon activité, on ajoutel'id du user dans la partie gestionnaire affecté
        // TODO : il faudra remettre en placeen ajoutant une condition : si pas statut a affecter
        // if (this.modeVisualisation === 'monActiviteProd') {
        //   this.$parent.gestionnaire = getUser().id;
        // }
      }
      if (this.$parent.gestionnaire) {
        this.$parent.gestionnaires.push({id: this.$parent.gestionnaire, nom: this.$parent.gestionnaireNom, prenom: this.$parent.gestionnairePrenom})
      }
      this.$parent.fromDashboard = 'fromDashboard'
      this.$parent.noSearch = ''
      if (isEmpty(this.$parent.traitementId)) {
        this.$parent.traitementId = this.getTraitementId();
        this.$parent.selectedTraitementId = this.getTraitementId();
      }
      this.$parent.$refs.dashboard_dossier_table.$refs.table.refresh();
    },
    setLoading(baskets){
      this.loadingBasket = [];
      for(let basket of baskets){
        this.loadingBasket[basket.id] = true;
      }
    },
    checkDashboardComplete() {
      let findLoading = false;

      for (let index in this.loadingBasket) {
        if (this.loadingBasket[index]) {
          findLoading = true;
        }
      }

      this.loadingDashboard = findLoading;
      // Si tout est fini on peut appeler la méthode qui génère les données pour le csv
      if (!findLoading) {
        this.fetchData();
      }
    },
    getGestionDashboard() {
      let self = this

      // this.$store.commit('IS_LOADING', true)
      this.loadingDashboard = true;
      this.$axios
        .get('/espaceGestion/dossier/dashboardGestion/'+this.modeVisualisation)
        .then(response => {
          // this.loadingDashboard = false;
          // this.$store.commit('IS_LOADING', false)
          // console.log(response.data)
          this.statusPrincipaux = response.data.statusPrincipaux
          this.statusTraites = response.data.statusTraites
          this.statusAlertes = response.data.statusAlertes
          this.statistiquesPrincipales = response.data.statsPrincipales
          this.statistiquesTraites = response.data.statsTraites
          //this.statistiquesAlertes = response.data.statsAlertes
          // this.statsAAffecter = response.data.statsAAffecter ? response.data.statsAAffecter : ''
          this.systemBaskets = response.data.basketsSysteme
          this.userBaskets = response.data.basketsUser ? response.data.basketsUser : []
        })
        .catch(function(error) {
          console.log(error)
          self.loadingDashboard = false;
          // self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getGestionDashboardBasketStats(baskets){
      let self = this
      if(!isEmpty(baskets)){
        let chunkedArray = _.chunk(baskets, 10);

        for (let chunk of chunkedArray) {
          let dataPost = {
            basketIds: chunk.map(row => row.id),
            modeVisualisation: this.modeVisualisation
          };
          this.$axios
            .post('/espaceGestion/dossier/getStatForBasketIds',dataPost)
            .then(async response => {
              if(this.modeVisualisation === response.data.modeVisualisation){
                for (let basketId in response.data.statsPrincipales) {
                    this.statistiquesPrincipales[basketId] = response.data.statsPrincipales[basketId];
                    this.statistiquesTraites[basketId] = response.data.statsTraites[basketId];
                    this.loadingBasket[basketId] = false;
                    this.checkDashboardComplete();
                }
              }
            })
            .catch(function(error) {
              console.log(error)
              // self.$store.commit('IS_LOADING', false)
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      }
    },
    disableColumn(column, statusP) {
      return (this.modeVisualisation !== 'monActiviteProd' || (this.modeVisualisation === 'monActiviteProd' && !this.canAffecte())) && statusP.libelle_technique === column
    },
    getTraitementId() {
      let userTreatments = getUser().profil_active[0].traitements;
      let traitementId = '';

      if (userTreatments.length === 1) {
        traitementId = userTreatments[0].id;
      }

      return traitementId;
    },
    canAffecte() {
      return hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AUTO_AFFECTE);
    },
    canDeleteBasket(basket) {
      let user = getUser()
      // console.log(user)
      return (this.$parent.canCreateBasketForAll() && basket.user_id === 0) || (this.$parent.canCreateBasket() && basket.user_id === user.id)
    },
    removeBasket(basketId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer cette corbeille ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/espaceGestion/dossier/basket/delete/"+basketId).then(response => {
                this.$store.commit("IS_LOADING", false)
                // console.log(response)
                this.canRenderGestionDashboard = false
                this.getGestionDashboard()
                // this.getBaskets()
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression de la corbeille. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    isManager() {
      let user = getUser();
      let isManager = false;
      isManager = isResponsableEquipe();
      // user.equipes.map( equipe => {
      //   if (equipe.pivot.role === 'responsable') {
      //     isManager = true
      //   }
      // })
      // Cas des admin dgp et superadmin
      let codesAdmin = ['ZZ','0A','Admin_DGPD','Admin_DGPA','DGP_RSPQ','DGP_RSP']
      if (codesAdmin.indexOf(user.profil_active[0].code) > -1) {
        isManager = true
      }
      return isManager
    },
    canManageService() {
      return hasRule(rules.CAN_MANAGE_SERVICE)
    },
    getStyle(basket) {
      let color = basket.couleur ? basket.couleur : '#cde2ec'
      // `background-color: ${basket.couleur}`
      // document.getElementById(basket.id).style.backgroundColor = basket.color
      return 'background-color: '+color
    },
    getTimestamp() {
      let date = new Date;
      let day = date.getDate().toString().length === 1 ? '0'+date.getDate().toString() : date.getDate().toString();
      let month = (date.getMonth()+1).toString().length === 1 ? '0'+(date.getMonth()+1).toString() : (date.getMonth()+1).toString();
      let year = date.getFullYear().toString();

      return day+'_'+month+'_'+year;
    },
    fetchData(){
      this.getTimestamp()
      // console.log('this.statistiquesTraites',this.statistiquesTraites)
      if (this.modeVisualisation === 'monServiceManagement' || this.modeVisualisation === 'monEquipeManagement') {
        this.excelData = [];
        let statusATraiterId = null;
        let statusEnAttenteId = null;
        let statusEnAttenteDpcId = null;
        for (let status of this.$parent.allStatus) {
          if (status.libelle_technique === 'a_traiter') {
            statusATraiterId = status.id;
          } else if (status.libelle_technique === 'en_attente') {
            statusEnAttenteId = status.id;
            for (let statusEnAttente of status.sous_statuts) {
              if (statusEnAttente.libelle_technique === 'en_attente_dpc') {
                statusEnAttenteDpcId = statusEnAttente.id;
              }
            }
          }
        }

        for (let gestionnaire of this.systemBaskets) {
          let statATraiter = 0;
          let statEnAttente = 0;
          let statEnAttenteDpc = 0;
          let statEnAttenteJ = 0;
          let statDpcJ = 0;
          let statTraiteJ = 0;
          let statTraiteS = 0;
          let statTotal = 0;
          let statByType = [];
          for (let statId in this.statistiquesPrincipales[gestionnaire.id]) {
            if (parseInt(statId, 10) === parseInt(statusATraiterId)) {
              statATraiter = this.statistiquesPrincipales[gestionnaire.id][statId]['stats'];
            } else if (parseInt(statId, 10) === parseInt(statusEnAttenteId)) {
              statEnAttente = this.statistiquesPrincipales[gestionnaire.id][statId]['stats'];
            } else if (parseInt(statId, 10) === parseInt(statusEnAttenteDpcId)) {
              statEnAttenteDpc = this.statistiquesPrincipales[gestionnaire.id][statId]['stats'];
            } else if (statId === 'total') {
              statTotal = this.statistiquesPrincipales[gestionnaire.id][statId]['stats'];
            }
            for (let typeId in this.statistiquesPrincipales[gestionnaire.id][statId]['type']) {
              if (isEmpty(statByType[typeId])) {
                statByType[typeId] = {
                  aTraiter: 0,
                  enAttente: 0,
                  enAttenteDpc: 0,
                  total: 0,
                  statEnAttenteJ: 0,
                  statDpcJ: 0,
                  statTraiteJ: 0,
                  statTraiteS: 0
                };
              }
              if (parseInt(statId, 10) === parseInt(statusATraiterId)) {
                statByType[typeId].aTraiter = this.statistiquesPrincipales[gestionnaire.id][statId]['type'][typeId];
              } else if (parseInt(statId, 10) === parseInt(statusEnAttenteId)) {
                statByType[typeId].enAttente = this.statistiquesPrincipales[gestionnaire.id][statId]['type'][typeId];
              } else if (parseInt(statId, 10) === parseInt(statusEnAttenteDpcId)) {
                statByType[typeId].enAttenteDpc = this.statistiquesPrincipales[gestionnaire.id][statId]['type'][typeId];
              } else if (statId === 'total') {
                statByType[typeId].total = this.statistiquesPrincipales[gestionnaire.id][statId]['type'][typeId];
              }
            }
          }
          if (this.statistiquesTraites[gestionnaire.id]) {
            for (let index in this.statistiquesTraites[gestionnaire.id]) {
              if (parseInt(index,10) === 0) {
                statEnAttenteJ = this.statistiquesTraites[gestionnaire.id][0]['stats'];
              } else if (parseInt(index,10) === 1) {
                statDpcJ = this.statistiquesTraites[gestionnaire.id][1]['stats'];
              } else if (parseInt(index,10) === 2) {
                statTraiteJ = this.statistiquesTraites[gestionnaire.id][2]['stats'];
              } else if (parseInt(index,10) === 3) {
                statTraiteS = this.statistiquesTraites[gestionnaire.id][3]['stats'];
              }
              for (let typeId in this.statistiquesTraites[gestionnaire.id][index]['type']) {
                if (isEmpty(statByType[typeId])) {
                  statByType[typeId] = {
                    aTraiter: 0,
                    enAttente: 0,
                    enAttenteDpc: 0,
                    total: 0,
                    statEnAttenteJ: 0,
                    statDpcJ: 0,
                    statTraiteJ: 0,
                    statTraiteS: 0
                  };
                }
                if (parseInt(index,10) === 0) {
                  statByType[typeId].statEnAttenteJ = this.statistiquesTraites[gestionnaire.id][index]['type'][typeId];
                } else if (parseInt(index,10) === 1) {
                  statByType[typeId].statDpcJ = this.statistiquesTraites[gestionnaire.id][index]['type'][typeId];
                } else if (parseInt(index,10) === 2) {
                  statByType[typeId].statTraiteJ = this.statistiquesTraites[gestionnaire.id][index]['type'][typeId];
                } else if (parseInt(index,10) === 3) {
                  statByType[typeId].statTraiteS = this.statistiquesTraites[gestionnaire.id][index]['type'][typeId];
                }

              }
            }
          }

          if (gestionnaire.nom) {
            this.excelData.push({
              gestionnaire: gestionnaire.nom.toUpperCase()+' '+gestionnaire.prenom.substring(0,1).toUpperCase()+gestionnaire.prenom.substring(1).toLowerCase(),
              profil: gestionnaire.libelle_profil,
              equipe: gestionnaire.libelle_equipe,
              a_traiter: statATraiter,
              en_attente: statEnAttente,
              en_attente_dpc: statEnAttenteDpc,
              total: statTotal,
              en_attente_j: statEnAttenteJ,
              en_attente_dpc_j: statDpcJ,
              traite_j: statTraiteJ,
              traite_s: statTraiteS,
            });
            for (let typeId in statByType) {
              this.excelData.push({
                gestionnaire: this.getLibelleType(typeId),
                profil: '',
                equipe: '',
                a_traiter: statByType[typeId].aTraiter,
                en_attente: statByType[typeId].enAttente,
                en_attente_dpc: statByType[typeId].enAttenteDpc,
                total: statByType[typeId].total,
                en_attente_j: statByType[typeId].statEnAttenteJ,
                en_attente_dpc_j: statByType[typeId].statDpcJ,
                traite_j: statByType[typeId].statTraiteJ,
                traite_s: statByType[typeId].statTraiteS,
              });
            }
          }
        }
      }
    },
    getFormatedNumber(number) {
      return new Intl.NumberFormat('fr-FR').format(number)
    },
    getLibelleType(typeId) {
      let libelle = this.$parent.allTypes.reduce((res, type) => {
        // console.log(type.id, typeId)
        return parseInt(type.code,10) === parseInt(typeId,10) ? type.name : res;
      },'');
      return libelle;
    },
    showTooltipStatType(basketId, statId) {
      let statusAAffecter = this.$parent.allStatus.reduce((res, status) => status.libelle_technique === 'a_affecter' ? status : res,{})
      if (isEmpty(statusAAffecter)) {
        return !isEmpty(this.statistiquesPrincipales[basketId][statId]['stats']) && this.statistiquesPrincipales[basketId][statId]['stats'];
      } else {
        return !isEmpty(this.statistiquesPrincipales[basketId][statId]['stats']) && this.statistiquesPrincipales[basketId][statId]['stats'] && statusAAffecter.id !== statId;
      }
    },
    getInfoGlobalDossier() {
      this.$axios
        .get('/espaceGestion/dossier/info-global-dossier')
        .then(response => {
          // console.log(response.data)
          if (!isEmpty(response.data.infos)) {
            this.infoGlobalDossier = '<span style="color: #80104b;">Total des dossiers à traiter : <b>'+Intl.NumberFormat('fr-FR').format(response.data.infos.nbDossier)+'</b> correspondant à <b>'+Intl.NumberFormat('fr-FR').format(response.data.infos.nbNir)+'</b> NIR différents.</span>';

            this.infoGestionnaireDossier = '<span style="color: #80104b;">Dont <b>'+Intl.NumberFormat('fr-FR').format(response.data.infos.nbDossierGestionnaire)+'</b> que vous avez à traiter correspondant à <b>'+Intl.NumberFormat('fr-FR').format(response.data.infos.nbNirGestionnaire)+'</b> NIR différents.</span>'

            this.infoGlobalDossierSup = '<ul class="mb-0 pl-3">';
            for(let row of response.data.infos.nbDossierType) {
              let type = !isEmpty(row.groupe) && row.groupe !== 'null' ? row.groupe : 'Sans type';
              let nbNir = !isEmpty(response.data.infos.nbNirType[row.groupe]) ? response.data.infos.nbNirType[row.groupe] : 0;
              this.infoGlobalDossierSup = this.infoGlobalDossierSup + '<li>' + type + ' : <b>' + row.count + '</b> dossiers pour <b>' + nbNir + '</b> NIR différents.</li>';
            }
            this.infoGlobalDossierSup = this.infoGlobalDossierSup + '</ul>';
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    // getBaskets() {
    //   let self = this

    //   // this.$store.commit('IS_LOADING', true)
    //   this.loadingDashboard = true;
    //   this.$axios
    //     .get('/espaceGestion/dossier/getAllUserBasketIds/'+this.modeVisualisation)
    //     .then(async response => {
    //       this.loadingDashboard = false;
    //       console.log('userBasket', response.data.data)
    //       let chunkedArray = _.chunk(response.data.data.systeme, 5);
    //       await this.setLoadingBasket(response.data.data)
    //       console.log('this.loadingBasket',this.loadingBasket)
    //       console.log('chuncked',chunkedArray)
    //       this.systemBaskets = response.data.data.systeme;
    //       for (let chunk of chunkedArray) {
    //         let dataPost = {
    //           basketIds: chunk.map(row => row.id),
    //           modeVisualisation: this.modeVisualisation
    //         };
    //         this.$axios
    //           .post('/espaceGestion/dossier/getStatForBasketIds',dataPost)
    //           .then(async response => {
    //             this.statusPrincipaux = response.data.statusPrincipaux
    //             this.statusTraites = response.data.statusTraites
    //             this.statusAlertes = response.data.statusAlertes
    //             this.statistiquesPrincipales = response.data.statsPrincipales
    //             this.statistiquesTraites = response.data.statsTraites
    //             //this.statistiquesAlertes = response.data.statsAlertes
    //             // this.statsAAffecter = response.data.statsAAffecter ? response.data.statsAAffecter : ''
    //             for (let basket of response.data.basketsSysteme) {
    //               this.systemBaskets.push(basket);
    //             }

    //             for (let basket of response.data.basketsSysteme) {
    //               console.log('basket.id',basket.id)
    //               this.loadingBasket[basket.id] = false;
    //               console.log('this.loadingBasket[basket.id]',this.loadingBasket[basket.id])
    //             }
    //           })
    //           .catch(function(error) {
    //             console.log(error)
    //             // self.$store.commit('IS_LOADING', false)
    //             self.$swal({
    //               position: 'top',
    //               type: 'error',
    //               title: 'Attention !!',
    //               text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
    //               showConfirmButton: false,
    //               timer: 5000
    //             })
    //           })
    //       }
    //       // this.userBaskets = response.data.basketsUser ? response.data.basketsUser : []
    //     })
    //     .catch(function(error) {
    //       console.log(error)
    //       self.loadingDashboard = false;
    //       // self.$store.commit('IS_LOADING', false)
    //       self.$swal({
    //         position: 'top',
    //         type: 'error',
    //         title: 'Attention !!',
    //         text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
    //         showConfirmButton: false,
    //         timer: 5000
    //       })
    //     })
    // },
    // setLoadingBasket(basketsGroup) {
    //   return new Promise(resolve => {
    //     let count = 0;
    //     let totalGroup = basketsGroup.length;
    //     for (let group in basketsGroup) {
    //       for (let basket of basketsGroup[group]) {
    //         this.loadingBasket[basket.id] = true;
    //       }
    //     }
    //     resolve();
    //   });
    // },
  }
}
</script>

<style>
table#dashboardGestion {
    max-height:500px;
    overflow-y:auto;
}

table#dashboardGestion thead tr:nth-child(1) th{
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>
